import React from 'react';
import type { Tools } from '../../../core/types';
import type { State, Type } from './state';
import { useCarousel, TRIGGER } from './state';
import ClickableDot from './ClickableDot';
import styles from './index.module.less';
import withEventTracking from '../../../utilities/withEventTracking';
import Element from '../../../core/Element';

export interface DotsProps {
  children?: React.ReactNode;
  inactive?: React.ReactNode;
  active?: React.ReactNode;
  clickAble?: boolean;
  onClick?: (state: State, type: Type) => void;
  tools?: Tools;
  customization?: {
    tracking?: {
      dot: Tools;
    };
  };
  headerIds?: string[];
}

const Dots = ({
  inactive = '*',
  active = '+',
  clickAble = false,
  onClick,
  customization,
  headerIds = [],
}: DotsProps): React.ReactElement => {
  const [state, navigate] = useCarousel();

  const { tracking: { dot: dotTools } = { dot: {} } } = customization || {};

  const onAction = (indx: number) => {
    navigate.current(indx, onClick, TRIGGER.DOT);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowLeft') {
      navigate.previous(onClick, TRIGGER.DOT);
    }
    if (event.key === 'ArrowRight') {
      navigate.next(onClick, TRIGGER.DOT);
    }
  };

  return (
    <Element
      onKeyDown={handleKeyPress}
      data-testid="dots-wrapper"
      className={styles.inlineFlex}
    >
      {Array.from({ length: state.totalItems }).map((_, i) => (
        <Element
          key={i}
          aria-describedby={headerIds?.[i]}
          className={styles.inlineFlex}
        >
          {clickAble ? (
            <ClickableDot
              active={i === state.currentIndex}
              onClick={() => onAction(i)}
              index={i}
              totalItems={state.totalItems}
              tools={
                dotTools && {
                  ...dotTools,
                  tracking: {
                    ...dotTools.tracking,
                    details: [
                      ...((dotTools &&
                        dotTools.tracking &&
                        dotTools.tracking.details) ||
                        []),
                      `${i + 1}`,
                    ],
                  },
                }
              }
            >
              {i === state.currentIndex ? active : inactive}
            </ClickableDot>
          ) : i === state.currentIndex ? (
            active
          ) : (
            inactive
          )}
        </Element>
      ))}
    </Element>
  );
};

export default withEventTracking<DotsProps>(Dots);
